import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Error.css';

const FALLBACK_MESSAGE = 'Ocorreu um erro inesperado, por favor contate o suporte e informe o código de erro';

function ErrorPage() {
  const params = new URLSearchParams(useLocation().search);
  const code = params.get('code');
  const [errorInfo, setErrorInfo] = useState({ message: '', description: '' });

  useEffect(() => {
    if (!code) {
      setErrorInfo({ message: FALLBACK_MESSAGE, description: '' });
      return;
    }

    fetch(`https://rvensino.com.br/get.php?action=get_error&code=${code}`)
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          setErrorInfo({ message: FALLBACK_MESSAGE, description: '' });
        } else {
          setErrorInfo({ message: data.error_message, description: data.error_description });
        }
      })
      .catch(() => setErrorInfo({ message: FALLBACK_MESSAGE, description: '' }));
  }, [code]);

  return (
    <div className='page-container login'>
      <div className='login-container'>
        <div className='error-page-box'>
          <img src="https://rveducacao.com.br/230616_RV_logo_principal_positivo-cor.png" alt="Logo" className='login-logo error' />
          <div className='error-message-container'>
            <p className='error-code'>{code ?? '?'}</p>
            <p className='error-message'>{errorInfo.message}</p>
            {errorInfo.description && <p className='error-description'>{errorInfo.description}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
